import { Themed } from "@components/atoms/Themed"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Home Page",
}

export default defineView("template-home", (props) => {
  return <ContentBlocks blocks={props.page?.contentBlocks} />
})
